import { StyledTabContainer, SecondaryTab } from "../../../Components/CustomTab";
import { FORM_TOKENS } from "../WorkOrders/WorkOrderFormShared";

// Sub-tab strip for the entity types.
//
// SecondaryTab / StyledTabContainer -- the platform's own sub-tab pair, used by
// the Digital Twin tab strip. Pills read as filter chips, which is a different
// promise: a chip narrows a list, a tab switches to a different one. These
// switch tables, so they are tabs.
//
// Grey with an underline on the selected one, rather than the purple of the
// module tabs directly above, so the two levels stay visually distinct.
//
// Labels come from config, so an org's own wording shows ("Battery Plant"
// rather than "Warehouse"), and order is the order of `types` -- there is no
// sortOrder anywhere in this module.

const EntityTypeTabs = ({ types = [], activeCode, onChange }) => {
    if (!types.length) return null;

    // Guarded because MUI logs and renders no selection when `value` matches no
    // Tab -- which is exactly the state during the render after a tab switch,
    // before the new types list has arrived.
    const value = types.some((t) => t.code === activeCode)
        ? activeCode
        : types[0].code;

    return (
        <StyledTabContainer
            value={value}
            onChange={(_, code) => onChange(code)}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            aria-label="Network entity types"
            sx={{
                // No px here: the page body supplies the inset, so the tabs,
                // the rule under them and the card below all line up on one
                // edge. Adding it here again would indent them by 48px.
                // mb: 2 and nothing else. Inventory's tab strip
                // (InventoryMain.jsx:472-476) is one box with mt:2 / mb:2 and a
                // bottom rule, and this now matches it. Spacing was previously
                // split between this margin and another on the table wrapper,
                // which added up to 24px of dead band the Inventory layout does
                // not have.
                mb: 2,
                minHeight: 0,
                // The rule under the whole strip is what makes these read as a
                // tab bar rather than a row of text buttons: the selected tab's
                // underline sits ON that line, so the active one is joined to
                // the panel below and the rest are detached from it.
                borderBottom: `1px solid ${FORM_TOKENS.cardBorder}`,
                "& .MuiTab-root": { px: 3 },
            }}
        >
            {types.map((type) => (
                <SecondaryTab
                    key={type.code}
                    value={type.code}
                    label={type.labelPlural || type.label}
                    data-testid={`network-entity-tab-${type.code}`}
                />
            ))}
        </StyledTabContainer>
    );
};

export default EntityTypeTabs;
